<template>
  <div 
    class="  px-10 mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <section>
          <div class="color-dark-blue fs-16 font-weight-bold">
            Ubah Kategori
          </div>

          <v-card 
            class="mt-0 box-shadow"
            height="calc(100vh - 180px)"
            style="background: transparent;">
            <v-card-text class="">

              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider
                        name="Nama Kategori Pengguna" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-12 label-input mb-2 font_weight_600 black_one">
                          Nama Kategori Pengguna
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. Admin"

                          
                          :item-color="set_color"

                          v-model="form.title"
                          :error-messages="errors"
                          required
                          class="fs-12"
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <div>
                    <div class="fs-12 font_weight_600 black_one label-input mb-2">
                      Hak Akses
                    </div>

                    <div
                      style="height: calc(100vh - 365px); overflow-y: auto;">
                      <v-treeview
                        dense
                        open-all
                        open-on-click

                        selectable
                        :item-disabled="disabled"
                        :selected-color="set_color"

                        rounded
                        transition

                        :items="list"
                        item-key="id"
                        item-text="label"

                        item-children="sub_menu"
                        class="non_border_tree fs-12 black_one"
                        
                        
                        return-object
                        
                        v-model="form.menu_arr">
                        <template v-slot:prepend="{ item }">
                          <!-- <v-img v-if="item.icon !== undefined"
                            width="20"
                            height="20"
                            alt="POS Amanata"  
                            :src="item.icon"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="18"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>

                          <v-icon v-else
                            size="18">
                            mdi-minus-thick
                          </v-icon> -->
                          <v-icon v-if="item.icon !== undefined"
                            size="18">
                            {{ item.icon }}
                          </v-icon>

                          <v-icon v-else
                            size="18">
                            mdi-minus-thick
                          </v-icon>
                        </template>
                      </v-treeview>
                    </div>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>


          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                color="#240087"
                class="body-2 white--text text-capitalize border-radius">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/category-user"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>

          <!-- <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
            </v-col>
          </v-row> -->
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        role: [
          {
            id: 1,
            name: 'Admin'
          },
          {
            id: 2,
            name: 'Pengguna' 
          }
        ],
        list:[
                  {
                    id: 1,
                    label: "Dashboard",
                    icon: "mdi-view-dashboard",
                    link: "/dashboard",
                    sub_menu:[]
                  },
                  {
                    id: 22,
                    label: "Data Pelanggan",
                    icon: "mdi-account-group",
                    link: "/pelanggan"
                  },
                  {
                    id: 45,
                    label: "Member E-Katalog",
                    icon: "mdi-account-multiple-outline",
                    link: "/member"
                  },
                  {
                    id: 28,
                    label: "Data Keuangan",
                    icon: "mdi-cash-multiple",
                    link: "/keuangan"
                  },
                  {
                    id: 2,
                    label: "Hak Akses",
                    icon: "mdi-shield-key",
                    link: "/category-user",
                    sub_menu:[]
                  },
                  {
                    id: 3,
                    label: "Pengguna",
                    icon: "mdi-account",
                    link: "/user",
                    sub_menu:[]
                  },
                  {
                    id: 4,
                    label: "Master Pembelian",
                    icon: "mdi-file-cog",
                    link: "/master-pembelian",
                    sub_menu: [
                      {
                          id: 5,
                          label: "Data Satuan",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/satuan",
                        },
                        {
                          id: 6,
                          label: "Data Kategori",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/kategori-item",
                        },
                        {
                          id: 7,
                          label: "Data Item",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/item",
                        },
                        {
                          id: 9,
                          label: "Data Bagian",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/lokasi",
                        },
                        {
                          id: 8,
                          label: "Data Supplier",
                          icon: "mdi-file-cog",
                          link: "/master-pembelian/supplier",
                        }
                      ]
                  },
                  {
                    id: 10,
                    label: "Pembelian",
                    icon: "mdi-cart",
                    link: "/pembelian",
                    sub_menu: [
                      {
                        id: 11,
                        label: "Permintaan",
                        icon: "mdi-cart",
                        link: "/pembelian/permintaan",
                      },
                      {
                        id: 42,
                        label: "Approval Permintaan",
                        icon: "mdi-cart",
                        link: "/pembelian/approval-permintaan",
                      },
                      {
                        id: 12,
                        label: "Pengadaan",
                        icon: "mdi-cart",
                        link: "/pembelian/pengadaan",
                      },
                      {
                        id: 13,
                        label: "Penerimaan",
                        icon: "mdi-cart",
                        link: "/pembelian/penerimaan",
                      },
                      {
                        id: 14,
                        label: "Persediaan",
                        icon: "mdi-cart",
                        link: "/pembelian/persediaan",
                      }
                    ]
                  },
                  {
                    id: 16,
                    label: "Master penjualan",
                    icon: "mdi-printer-pos-cog-outline",
                    link: "/master-penjualan",
                    sub_menu: [
                    {
                        id: 15,
                        label: "Data Satuan",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/satuan",
                      },
                    {
                        id: 17,
                        label: "Kategori Produk",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/produk",
                      },
                      {
                        id: 18,
                        label: "Kategori Layanan",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/layanan",
                      },
                      {
                        id: 19,
                        label: "Kategori Paket",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/paket",
                      },
                      {
                        id: 20,
                        label: "Data Produk",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/item-penjualan-product",
                      },
                      {
                        id: 49,
                        label: "Data Topping",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/item-penjualan-topping",
                      },
                      {
                        id: 38,
                        label: "Data Layanan",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/item-penjualan-layanan",
                      },
                      {
                        id: 21,
                        label: "Data Paket",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/item-penjualan-paket",
                      },
                      {
                        id: 27,
                        label: "Tipe Penjualan",
                        icon: "mdi-printer-pos-cog-outline",
                        link: "/master-penjualan/type-penjualan"
                      },
                      // {
                      //   id: 37,
                      //   label: "Banner",
                      //   icon: "mdi-printer-pos-cog-outline",
                      //   link: "/master-penjualan/banner"
                      // }
                    ]
                  },
                  // {
                  //   id: 21,
                  //   label: "Item Sales",
                  //   icon: "mdi-package-variant-closed",
                  //   link: "/item-sales",
                  //   sub_menu:[
                  //     {
                  //       id: 22,
                  //       label: "Produk & Layanan",
                  //       icon: "mdi-package-variant-closed",
                  //       link: "/item-sales/product",
                  //     },
                  //     {
                  //       id: 23,
                  //       label: "Paket",
                  //       icon: "mdi-package-variant-closed",
                  //       link: "/item-sales/paket",
                  //     }
                  //   ]
                  // },
                  
                  {
                    id: 23,
                    label: "Shift Kasir",
                    icon: "mdi-printer",
                    link: "/shift-kasir",
                    sub_menu:[]
                  },
                  // {
                  //   id: 29,
                  //   label: "Tipe Penjualan",
                  //   icon:"mdi-percent-box",
                  //   link: "/type-penjualan",
                  //   sub_menu:[]
                  // },
                  {
                    id: 24,
                    label: "Transaksi",
                    icon: "mdi-cash",
                    link: "/sales-order",
                    sub_menu:[
                      {
                        id: 44,
                        label: "Transaksi Pesanan",
                        icon: "mdi-cash",
                        link: "/sales-order/pesanan",
                      },
                      {
                        id: 25,
                        label: "Transaksi Berlangsung",
                        icon: "mdi-cash",
                        link: "/sales-order/berlangsung",
                      },
                      {
                        id: 26,
                        label: "Transaksi Selesai",
                        icon: "mdi-cash",
                        link: "/sales-order/selesai",
                      },
                      {
                        id: 43,
                        label: "Transaksi Dihapus",
                        icon: "mdi-cash",
                        link: "/sales-order/hapus",
                      },
                      {
                        id: 46,
                        label: "Transaksi Pesanan Ditolak",
                        icon: "mdi-cash",
                        link: "/sales-order/pesanan-ditolak",
                      },
                      {
                        id: 47,
                        label: "Transaksi Verifikasi Pembayaran",
                        icon: "mdi-cash",
                        link: "/sales-order/verifikasi-pembayaran",
                      },
                      {
                        id: 48,
                        label: "Transaksi Ditolak",
                        icon: "mdi-cash",
                        link: "/sales-order/transaksi-ditolak",
                      }
                    ]
                  },
                  {
                    id: 29,
                    label: "Laporan",
                    icon: "mdi-file-chart-outline",
                    link: "/report",
                    sub_menu:[
                      {
                        id: 30,
                        label: "Laporan Penjualan",
                        icon: "mdi-file-chart-outline",
                        link: "/report/harian",
                      },
                      {
                        id: 36,
                        label: "Penjualan Per Produk",
                        icon: "mdi-file-chart-outline",
                        link: "/report/varian",
                      },
                      { 
                        id: 31,
                        label: "Penjualan Per Kategori",
                        icon: "mdi-file-chart-outline",
                        link: "/report/kategori",
                      },
                      {
                        id: 33,
                        label: "Penjualan Per Pelanggan",
                        icon: "mdi-file-chart-outline",
                        link: "/report/pelanggan",
                      },
                      {
                        id: 35,
                        label: "Penjualan Per Tipe Penjualan",
                        icon: "mdi-file-chart-outline",
                        link: "/report/tipe-penjualan",
                      },
                      {
                        id: 32,
                        label: "Penjualan Per Metode Pembayaran",
                        icon: "mdi-file-chart-outline",
                        link: "/report/metode-pembayaran",
                      },
                      {
                        id: 34,
                        label: "Penjualan Riwayat Transaksi Pelanggan",
                        icon: "mdi-file-chart-outline",
                        link: "/report/riwayat-transaksi",
                      }
                    ]
                  },
                  {
                    id: 39,
                    label: "Konfigurasi",
                    icon: "mdi-file-cog",
                    link: "/konfigurasi",
                    sub_menu: [
                      {
                        id: 40,
                        label: "import Produk",
                        icon: "mdi-file-cog",
                        link: "/konfigurasi/import-product"
                      },
                      {
                        id: 41,
                        label: "Konfigurasi Outlet",
                        icon: "mdi-file-cog",
                        link: "/konfigurasi/outlet"
                      }
                    ]
                  }
                  // {
                  //   id: 15,
                  //   label: "Master Data",
                  //   icon: "mdi-cog-outline",
                  //   link: "/master",
                  //   sub_menu: [
                  //     {
                  //       id: 16,
                  //       label: "Data Satuan",
                  //       icon: "mdi-cog-outline",
                  //       link: "/master/satuan",
                  //     },
                  //     {
                  //       id: 24,
                  //       label: "Data Pelanggan",
                  //       icon: "mdi-cog-outline",
                  //       link: "/master/pelanggan"
                  //     },
                  //     {
                  //       id: 29,
                  //       label: "Tipe Penjualan",
                  //       icon: "mdi-cog-outline",
                  //       link: "/master/type-penjualan"
                  //     },
                  //     {
                  //       id: 30,
                  //       label: "Data Bank",
                  //       icon: "mdi-cog-outline",
                  //       link: "/master/bank"
                  //     },
                  //   ]
                  // }
                  ],

        form: {
          id: '',
          title: '',
          menu_arr: []
        },

        process: {
          load: false,

          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      'form.id': function() {
        let t = this

        let r = this.role.filter(function(v) {
          return t.form.id == v.id
        })

        if (r.length > 0) {
          this.form.title = r[0].name
          
          this.fetchRole()
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      outlet () {
        return this.$store.state.outlet
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      this.fetch()
    },
    mounted () {
      
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        this.form.menu_arr = []

        await get('pos/cat/data', { params })
        .then(response => {
          let res = response.data

          this.process.laod = false
            
          if (res.status === 200) {
            this.form.id = res.results.data[0].id
            this.form.title = res.results.data[0].title
            let data_menu = res.results.data[0].menu_arr.length > 0 ? JSON.parse(res.results.data[0].menu_arr) : []
            // let data = res.results.data.length > 0 ? JSON.parse(res.results.data[0].menu_arr) : []
            let list = []
            this.list.map(obj => {
              list.push(
                {
                  ...obj,
                  disabled: false
                }
              )
            })
            if (this.form.title === 'Kasir') {
              list.map(obj => {
                if (obj.link.includes('/pelanggan') || obj.link.includes('/member') || obj.link.includes('/master-penjualan') || obj.link.includes('/shift-kasir') || obj.link.includes('/sales-order') || obj.link.includes('/report') || obj.link.includes('/keuangan')) {
                  obj.disabled = true
                }
              })
            }
            this.list = list
            let data = []
            for (let i = 0; i < data_menu.length; i++) {
              data.push(
                {
                  ...data_menu[i],
                  disabled: false
                }
              )
            }

            if (this.form.title === 'Kasir') {
              data.map(obj => {
                if (obj.link.includes('/pelanggan') || obj.link.includes('/member') || obj.link.includes('/master-penjualan') || obj.link.includes('/shift-kasir') || obj.link.includes('/sales-order') || obj.link.includes('/report') || obj.link.includes('/keuangan')) {
                  obj.disabled = true
                }
              })
            }

            data.map(obj => {
              if (!obj.link.includes('/master-pembelian') && !obj.link.includes('/pembelian') && !obj.link.includes('/master') && !obj.link.includes('/master-penjualan') && !obj.link.includes('/item-sales') && !obj.link.includes('/sales-order') && !obj.link.includes('/report') && !obj.link.includes('/konfigurasi')) {
                this.form.menu_arr.push(obj)
              } else {
                if (obj.link.includes('/master-pembelian')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/pembelian')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/master')) {
                  console.log('test')
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/master-penjualan')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/item-sales')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                } 

                if (obj.link.includes('/sales-order')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/report')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/konfigurasi')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }
              }
            })

            this.form.menu_arr.sort((a, b) => a.id - b.id)
          }
        })
      },
      array_parent () {
        let menu_arr = this.form.menu_arr, menu_fix  = []

        menu_arr.map(obj => {
          // if (!obj.link.includes('/pekerjaan/') && !obj.link.includes('/laporan/') && !obj.link.includes('/peta/') && !obj.link.includes('/master/')) {
          if (!obj.link.includes('/master-pembelian/') && !obj.link.includes('/master/') && !obj.link.includes('/pembelian/') && !obj.link.includes('/master-penjualan/') && !obj.link.includes('/item-sales/') && !obj.link.includes('/sales-order/') && !obj.link.includes('/report/') && !obj.link.includes('/konfigurasi/')) {
            menu_fix.push(obj)
          } else {

            if (obj.link.includes('/master-pembelian/')) {
              menu_fix.push({
                id: 4,
                label: "Master Pembelian",
                icon: "mdi-cart",
                link: "/master-pembelian",
                sub_menu: []
              })
            }

            if (obj.link.includes('/pembelian/')) {
              menu_fix.push({
                id: 10,
                label: "Pembelian",
                icon: "mdi-cart",
                link: "/pembelian",
                sub_menu: []
              })
            }

            if (obj.link.includes('/master/')) {
              menu_fix.push({
                id: 15,
                label: "Master",
                icon: "mdi-cog-outline",
                link: "/master",
                sub_menu: []
              })
            }

            if (obj.link.includes('/master-penjualan/')) {
              menu_fix.push({
                id: 17,
                label: "Master Penjualan",
                icon: "mdi-printer-pos-cog-outline",
                link: "/master-penjualan",
                sub_menu: []
              })
            }

            if (obj.link.includes('/item-sales/')) {
              menu_fix.push({
                id: 21,
                label: "Produk",
                icon: "mdi-package-variant-closed",
                link: "/item-sales",
                sub_menu: []
              })
            }

            if (obj.link.includes('/sales-order/')) {
              menu_fix.push({
                id: 24,
                label: "Transaksi",
                icon: "mdi-cash",
                link: "/sales-order",
                sub_menu: []
              })
            }

            if (obj.link.includes('/report/')) {
              menu_fix.push({
                id: 29,
                label: "Laporan",
                icon: "mdi-file-chart-outline",
                link: "/report",
                sub_menu: []
              })
            }

            if (obj.link.includes('/konfigurasi/')) {
              menu_fix.push({
                id: 39,
                label: "Konfigurasi",
                icon: "mdi-file-cog",
                link: "/konfigurasi",
                sub_menu: []
              })
            }

          }
        })

        menu_fix = this.array_same(menu_fix)

        return menu_fix
      },
      array_same (arr) {
        let result = arr.reduce((unique, o) => {
            if(!unique.some(obj => obj.id === o.id)) {
              unique.push(o)
            }
            return unique
        },[])

        return result.sort((a, b) => a.id - b.id)
      },
      array_final () {
        let menu_form = this.form.menu_arr, menu_fix = this.array_parent()
        
        menu_form.map(obj => {
          menu_fix.map(obj_sub => {

            if (obj.link.includes('/master-pembelian/') && obj_sub.link === '/master-pembelian') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/pembelian/') && obj_sub.link === '/pembelian') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/master/') && obj_sub.link === '/master') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/master-penjualan/') && obj_sub.link === '/master-penjualan') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/item-sales/') && obj_sub.link === '/item-sales') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/sales-order/') && obj_sub.link === '/sales-order') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/report/') && obj_sub.link === '/report') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/konfigurasi/') && obj_sub.link === '/konfigurasi') {
              obj_sub.sub_menu.push(obj)
            }
          })
        })

        return menu_fix
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          let array_menu = []

          // if (this.form.title === 'Kasir') {
          //   this.array_final().map((obj, index) => {
          //     if (obj.link.includes('/pelanggan') || obj.link.includes('/keuangan')) {
          //       if (obj.link.includes('/pelanggan')) {
          //         this.array_final()[index] = {
          //           id: 22,
          //           label: "Data Pelanggan",
          //           icon: "mdi-account-group",
          //           link: "/pelanggan"
          //         }
          //       }
          //     }
            
          //   })
          // }

          this.array_final().map((obj, index) => {
            if (!obj.link.includes('/pelanggan') && !obj.link.includes('/keuangan') && !obj.link.includes('/dashboard') && !obj.link.includes('/shift-kasir') && !obj.link.includes('/user') && !obj.link.includes('/category-user') && !obj.link.includes('/member')) {
              array_menu.push(obj)
            } else {
              if (obj.link.includes('/member')) {
                array_menu.push({
                  id: 45,
                  label: "Member E-Katalog",
                  icon: "mdi-account-multiple-outline",
                  link: "/member"
                })
              }
              
              if (obj.link.includes('/pelanggan')) {
                array_menu.push({
                  id: 22,
                  label: "Data Pelanggan",
                  icon: "mdi-account-group",
                  link: "/pelanggan"
                })
              }

              if (obj.link.includes('/keuangan')) {
                array_menu.push({
                  id: 28,
                  label: "Data Keuangan",
                  icon: "mdi-cash-multiple",
                  link: "/keuangan"
                })
              }

              if (obj.link.includes('/dashboard')) {
                array_menu.push({
                  id: 1,
                  label: "Dashboard",
                  icon: "mdi-view-dashboard",
                  link: "/dashboard"
                })
              }

              if (obj.link.includes('/shift-kasir')) {
                array_menu.push({
                  id: 23,
                  label: "Shift Kasir",
                  icon: "mdi-printer",
                  link: "/shift-kasir"
                })
              }

              if (obj.link.includes('/user')) {
                array_menu.push({
                  id: 3,
                  label: "Pengguna",
                  icon: "mdi-account",
                  link: "/user"
                })
              }

              if (obj.link.includes('/category-user')) {
                array_menu.push({
                  id: 2,
                  label: "Hak Akses",
                  icon: "mdi-shield-key",
                  link: "/category-user"
                })
              }
            }
          })
          console.log(array_menu)

          this.form.menu_arr = JSON.stringify(this.array_final())

          // this.form.menu_arr = JSON.stringify(this.list)

          // SAVE TO REST API
          await post('pos/cat/update', {
            data: {
              id: this.form.id,
              title: this.form.title,
              menu_arr: JSON.stringify(array_menu)
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message
              this.$router.push({ path: '/category-user' })

              // this.fetchRole()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>